import setAutomationWorkflowRunLogsModal from '@/redux/actions/uiActions/setAutomationWorkflowRunLogsModal.js';
import setWorkflowTestSaved from '@/redux/actions/uiActions/setWorkflowTestSaved.js';
import { activeThreadDraftWorkflow } from '@/redux/selectors/pieveSelectors/composerResolutionSelectors.js';
import { automationWorkflowRunLogsModal } from '@/redux/selectors/uiSelectors.js';

/* Pieve prepared the workflow's test (workflow.test.updated, pushed with the stored test and its revision): it is the
   test now, and the person reviews it and presses Run test. The Test window opens on it, or shows it if already open,
   for the workflow on screen only (its thread's draft, or the window already open on it); anywhere else the message
   says it. Replaced reading the tool's result out of the transcript stream on 2026-10-02. */
const handleWorkflowTestUpdatedEvent = ({ payload, dispatch, getState }) => {
  const { workflowId, test } = payload?.data || {};

  if (!workflowId || !test) {
    return;
  }

  const state = getState();
  const modal = automationWorkflowRunLogsModal(state);
  const isWindowOnIt = modal?.open && modal.isTestSetup && !modal.workflowRunId && modal.workflowId === workflowId;
  const isOnScreen = String(activeThreadDraftWorkflow(state)?.workflowId || '') === workflowId;

  dispatch(setWorkflowTestSaved({ workflowId, test }));
  dispatch({ type: 'uiSetEventKey', payload: { key: 'workflowTestUpdated' } });

  if (!isWindowOnIt && isOnScreen) {
    dispatch(setAutomationWorkflowRunLogsModal({ open: true, workflowId, isTestSetup: true }));
  }
};

export default handleWorkflowTestUpdatedEvent;
